export const easingSeconds = "0.6s";
export const rapidEasing = "250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms";
